
import ProductListController from '~/components/product-list/ProductListController'

export default {
  name: 'SearchEmpty',
  components: {
    ProductListController,
  },
}
